/*
 Convention: https://docs.google.com/document/d/1ePqfM41II2CNBYpTuOgjLZafRkn6vABQ5NF40JGER1E/edit
 Review Reference: https://docs.google.com/document/d/1Diu8ZwKXPOWCsH2ry8rufCYADGFcHtR4MY3k1c3Ypes/edit

 ! Review
 TODO Disbursement - need to be refactored
 */
import keyMirror from 'src/utilities/keyMirror';

export const ACTION_TYPES = keyMirror({
  CLAIM_FUND_SUBMIT: null,
  CLAIM_FUND_SUBMIT_SUCCESS: null,
  CLAIM_FUND_SUBMIT_FAILED: null,

  CLAIM_FUND_RESET_SUBMIT: null,

  CLAIM_FUND_FETCH_DETAIL: null,
  CLAIM_FUND_FETCH_DETAIL_SUCCESS: null,
  CLAIM_FUND_FETCH_DETAIL_FAILED: null,

  CLAIM_FUND_SELECT_BANK_RESULT: null,

  CLAIM_FUND_INQUIRY: null,
  CLAIM_FUND_INQUIRY_SUCCESS: null,
  CLAIM_FUND_INQUIRY_FAILED: null,

  CLAIM_FUND_ADD_USER_DATA: null,
  CLAIM_FUND_ADD_USER_DATA_SUCCESS: null,
  CLAIM_FUND_ADD_USER_DATA_FAILED: null,

  CLAIM_FUND_ACTION: null,
  CLAIM_FUND_ACTION_SUCCESS: null,
  CLAIM_FUND_ACTION_FAILED: null,
  CLAIM_FUND_ACTION_RESET: null,

  CLAIM_FUND_FETCH_REGISTRATION: null,
  CLAIM_FUND_FETCH_REGISTRATION_SUCCESS: null,
  CLAIM_FUND_FETCH_REGISTRATION_FAILED: null,
});
